import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const MarketPreview = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Mock market data
  const marketData = [
    {
      symbol: 'BTC/USD',
      price: 43250.75,
      change: 2.45,
      changePercent: 5.67
    },
    {
      symbol: 'ETH/USD',
      price: 2845.32,
      change: -15.23,
      changePercent: -0.53
    },
    {
      symbol: 'ADA/USD',
      price: 0.4567,
      change: 0.0123,
      changePercent: 2.77
    },
    {
      symbol: 'SOL/USD',
      price: 98.45,
      change: 4.32,
      changePercent: 4.58
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: price < 1 ? 4 : 2
    })?.format(price);
  };

  const formatChange = (change) => {
    const sign = change >= 0 ? '+' : '';
    return `${sign}${change?.toFixed(2)}`;
  };

  const formatPercent = (percent) => {
    const sign = percent >= 0 ? '+' : '';
    return `${sign}${percent?.toFixed(2)}%`;
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-2">Live Market Data</h3>
        <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={14} />
          <span>{currentTime?.toLocaleTimeString()}</span>
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
        </div>
      </div>
      {/* Market Data */}
      <div className="space-y-3">
        {marketData?.map((coin, index) => (
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-4 hover:bg-muted/20 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                  <Icon name="TrendingUp" size={16} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">{coin?.symbol}</p>
                  <p className="text-xs text-muted-foreground">Real-time</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-foreground">
                  {formatPrice(coin?.price)}
                </p>
                <div className="flex items-center space-x-1">
                  <Icon
                    name={coin?.change >= 0 ? "TrendingUp" : "TrendingDown"}
                    size={12}
                    color={coin?.change >= 0 ? "var(--color-success)" : "var(--color-error)"}
                  />
                  <span
                    className={`text-xs font-medium ${
                      coin?.change >= 0 ? 'text-success' : 'text-error'
                    }`}
                  >
                    {formatChange(coin?.change)} ({formatPercent(coin?.changePercent)})
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Platform Benefits */}
      <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-lg p-4 border border-primary/20">
        <div className="text-center">
          <Icon name="BarChart3" size={24} color="var(--color-primary)" className="mx-auto mb-2" />
          <h4 className="text-sm font-semibold text-foreground mb-1">
            Advanced Trading Tools
          </h4>
          <p className="text-xs text-muted-foreground mb-3">
            Access professional-grade analysis with PTS-WIZARD-V3 algorithm
          </p>
          <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
            <div className="flex items-center space-x-1">
              <Icon name="Zap" size={12} />
              <span>Real-time</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Shield" size={12} />
              <span>Secure</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="TrendingUp" size={12} />
              <span>Profitable</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketPreview;